import styled from '@emotion/styled';
// import { Box, CssBaseline, Grid, Paper, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { Box, CssBaseline } from '@mui/material';
import {
  bottomBarDimen,
  mainAppBarDimen,
  toolBarDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameState } from '../MainFrame';

const Main = styled('main', { shouldForwardProp: props => true })(props => {
  const { isToolbarOpen, isRightDrawerOpen, isRightDrawer } = props;
  return {
    // border: '1px solid red',

    width: '100%',
    // marginBottom: toPixel(bottomBarDimen.height),
    marginTop: toPixel(mainAppBarDimen.height),
    flexWrap: 'wrap',
    ...(isToolbarOpen && {
      marginTop: toPixel(toolBarDimen.height + mainAppBarDimen.height),
    }),
    ...(isRightDrawerOpen &&
      isRightDrawer && {
        marginRight: 0, //toPixel(rightDrawerDimen.open.width),
      }),
    ...(!isRightDrawerOpen &&
      isRightDrawer && {
        marginRight: 0, //toPixel(rightDrawerDimen.closed.width),
      }),
    // transition: theme.transitions.create(["width", "margin"], {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
  };
});

const MainContent = props => {
  //global context
  const { isToolbarOpen, isRightDrawerOpen, mainDrawerOpen, isRightDrawer } =
    useMainFrameState();
  //end

  return (
    <>
      <Main
        isRightDrawerOpen={isRightDrawerOpen}
        isToolbarOpen={isToolbarOpen}
        mainDrawerOpen={mainDrawerOpen}
        isRightDrawer={isRightDrawer}
      >
        <CssBaseline />

        {/* <Box sx={{ border: '1px solid blue', height: '81vh' }}>{props.children}</Box> */}
        {props.children}
      </Main>
    </>
  );
};

export default MainContent;
